import Nullstack from 'nullstack';
export default function IconBrandDribbble({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-dribbble",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("path", {
    d: "M9 3.6c5 6 7 10.5 7.5 16.2"
  }), "   ", Nullstack.element("path", {
    d: "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
  }), "   ", Nullstack.element("path", {
    d: "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
  }), " ");
}